import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';

// Component Imports
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Feature Imports
import Intro from './components/Intro';
import CustomCursor from './components/CustomCursor';
import ScrollProgress from './components/ScrollProgress';
import Terminal from './components/Terminal';
import MatrixRain from './components/MatrixRain';
import Tracker from './components/Tracker';
import LiveEditor from './components/LiveEditor';

// import './App.css'; // index.css is usually imported in index.js, but keeping if you need

function App() {
  const [loading, setLoading] = useState(true);
  const [hackerMode, setHackerMode] = useState(false);

  // 1. Intro Animation Logic
  useEffect(() => {
    setLoading(true);
    // Uncomment below if you want Intro only once per session
    // const hasVisited = sessionStorage.getItem('hasVisited');
    // if (hasVisited) { setLoading(false); }
  }, []);

  const handleIntroComplete = () => {
    setLoading(false);
    // sessionStorage.setItem('hasVisited', 'true'); 
  };

  // 2. 🔥 Konami Code Logic (Cheat Code: Up, Down, Left, Right, B, A)
  useEffect(() => {
    const konamiCode = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    let currentPos = 0;

    const handleKeyDown = (e) => {
      if (e.key === konamiCode[currentPos]) {
        currentPos++;
        if (currentPos === konamiCode.length) {
          setHackerMode(true);
          alert("🐇 ACCESS GRANTED: WELCOME TO THE MATRIX");
          currentPos = 0;
        }
      } else {
        currentPos = 0;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // 3. 🕵️‍♂️ Developer Console Easter Egg
  useEffect(() => {
    console.clear();
    const style = "background: #000; color: #06b6d4; font-size: 20px; font-weight: bold; padding: 10px; border: 2px solid #a855f7; border-radius: 5px;";
    console.log("%c🚀 Hello, Developer/Recruiter!", style);
    console.log("%cLooking for the bugs? I squashed them all. \nBut if you want to see the code, check my GitHub: https://github.com/princedesai012", "color: #cbd5e1; font-size: 14px;");
    console.log("%cSystem Status: OPTIMIZED 🟢", "color: #22c55e; font-weight: bold;");
  }, []);

  // 4. 🔥 Smart Tab Title Logic (Don't Leave Me)
  useEffect(() => {
    const originalTitle = document.title;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        document.title = "⚠️ System Alert: User Missing!";
      } else {
        document.title = originalTitle;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  // App.js ke andar
  useEffect(() => {
    // Sirf buttons aur links par vibration lagao
    const handleClick = (e) => {
      // Check karo agar click kiya gaya element button ya link hai
      if (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.closest('button') || e.target.closest('a')) {
        // Agar browser support karta hai
        if (navigator.vibrate) {
          navigator.vibrate(150); // 15ms ka chhota jhatka
        }
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="App">
      <AnimatePresence mode='wait'>
        {loading ? (
          <Intro key="intro" onComplete={handleIntroComplete} />
        ) : (
          <>
            {/* --- LAYERS & UTILITIES --- */}

            {/* 1. Hacker Mode Overlay */}
            {hackerMode && <MatrixRain />}

            {/* 2. Background Grid */}
            <div className="bg-grid"></div>

            {/* 3. Invisible Tracker (Silent) */}
            <Tracker />

            {/* 4. Chaos Mode (The Red Button) */}
            {/* <ChaosMode />  */}

            {/* 5. Custom UI Elements */}
            <CustomCursor />
            <ScrollProgress />

            {/* 6. Dev Tools (Stacked Bottom Right) */}
            <Terminal />
            <LiveEditor />

            {/* --- MAIN CONTENT --- */}
            <Navbar />
            <Hero />
            <About />
            <Experience />
            <Projects />
            <Contact />
            <Footer />
          </>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;